export default "__VITE_ASSET__BmTi_wN5__"